import './DashboardDetailsPage.css';

import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LoginContext } from '../../../App';
import { B2BContentContext } from '../../layout/Layout';
import { showNotification } from '../../b2b-common/Notification';
import { deleteWidget, fetchDashboard } from '../../../services/b2b-reporting-apiServices';
import DashboardGrid from '../components/DashboardGrid';
import EditWidgetModal from '../forms/EditWidgetModal';
import { Box } from '@mui/material';
import DashboardTabHeader from '../components/DashboardTabHeader';

const DashboardDetailsPage = () => {
    const { loginData } = useContext(LoginContext);
    const [error, setError] = useState(null);
    const { setNotification } = useContext(B2BContentContext);

    const { dashboardId } = useParams();

    const [currentDashboard, setCurrentDashboard] = useState(null);
    const [currentWidget, setCurrentWidget] = useState(null);
    const [openEditWidgetModal, setOpenEditWidgetModal] = useState(false);

    const gettingDashboardData = async () => {
        const { accessToken, loggedOrganizationUuid } = loginData;
        try {
            const dashboardData = await fetchDashboard(accessToken, loggedOrganizationUuid, dashboardId);
            setCurrentDashboard(dashboardData);
        } catch (error) {
            setError(error.message);
            showNotification(setNotification, 'Error fetching dashboard data: ' + error.message, 'error', 3000);
        }
    }

    useEffect(() => {
        if ((currentDashboard === null) || (currentDashboard.dashboardId !== dashboardId)) {
            gettingDashboardData();
        }
    }, [dashboardId, loginData]);

    if (currentDashboard === null) {
        return <h1>Loading...</h1>;
    }

    const handleDeleteWidget = async (widgetId) => {
        try {
            const response = await deleteWidget(loginData.accessToken, loginData.loggedOrganizationUuid, dashboardId, widgetId);
            await gettingDashboardData();
            showNotification(setNotification, 'Widget deleted', 'success', 3000);
        } catch (error) {
            setError(error.message);
            showNotification(setNotification, 'Error deleting widget: ' + error.message, 'error', 3000);
        }
    }

    const handleSavedWidget = async () => {
        try {
            await gettingDashboardData();
            setOpenEditWidgetModal(false);
        } catch (error) {
            setError(error.message);
            showNotification(setNotification, 'Error retrieving dashboard data: ' + error.message, 'error', 3000);
        }
    }

    const handleEditWidget = (widget) => {
        setCurrentWidget(widget);
        setOpenEditWidgetModal(true);
    }

    const { rows, columns } = currentDashboard.dashboardConfig;

    return (
        <Box className='dashboard-details-page'>
            <DashboardTabHeader dashboard={currentDashboard} className={'dashboard-details-page-tabs'} />
            <DashboardGrid rows={rows} columns={columns} widgets={currentDashboard.widgets} onWidgetDeleted={handleDeleteWidget} onEditWidget={handleEditWidget} />
            <EditWidgetModal dashboard={currentDashboard} widget={currentWidget} open={openEditWidgetModal} onCancel={() => setOpenEditWidgetModal(false)} onSaved={handleSavedWidget} />
        </Box>
    );
};

export default DashboardDetailsPage;